/**
 * Searches a tree for a node representing the current org of the user and adds that node and all it's
 * available parent's to an array that is returned
 * 
 * @param {Array} data An array containing a single root object which contains an array of children and so on
 * @param {Number} target The orgId being searched for (the user's current org)
 * @param {Array} results The array to populate with nodes that should expand (all parents leading to the currrent org but no others)
 * @returns An array of string node IDs that should be expanded when the org picker is opened
 */
export function getNodesToExpand(data, target, results){
    if(data.length === 0) {
        return false; 
    }

    return data.some(node => {
        if(node.id == target){
            results.push(node.id.toString());
            return true;
        }
        if(getNodesToExpand(node.children, target, results)){
            results.push(node.id.toString());
            return true;
        }
    });
}
